import {
    eventScreenControlFromService
} from '../../../components/wildix-remote-control/actions';

import { responseWiService } from '../actions';
import {
    WIS_DOMAIN,
    WIS_MESSAGE_TYPE,
    WIS_EVENTS, WIS_MESSAGE_APP
} from '../constants';

import authorizeWis from './authorizeWis';
import getWisMessageInfo from './getWisMessageInfo';
import handleHeadsetEvents from './handleHeadsetEvents';

let wisSocket = null;
const minPort = 8888;
const maxPort = 8890;
const reconnectionAttempts = 5;
const oneSecond = 1000;

function getNextPort(currentPort) {
    let nextPort;

    if (!currentPort) {
        nextPort = minPort;
    } else if (currentPort < maxPort) {
        nextPort = currentPort + 1;
    }

    return nextPort;
}

/**
 * Waiting until socket is ready
 *
 * @param socket
 * @return {Promise<Promise<unknown> | Promise.Promise>}
 */
async function isOpenWisConnection(socket) {
    return new Promise(resolve => {
        let counter = 0;

        const checker = (sock, resolver) => {
            // readyState 1 - means the socket is open
            if (sock.readyState === 1) {
                return resolver(true);
            }

            if (counter >= reconnectionAttempts) {
                return resolver(false);
            }

            counter++;
            setTimeout(() => {
                checker(sock, resolver);
            }, oneSecond);
        };

        checker(socket, resolve);
    });
}

function onConnectionOpened(socket) {
    authorizeWis(socket);
}

function onConnectionClosed() {
    const { isConnected } = APP.store.getState()['wildix/features/wiservice'];

    // try to reconnect only in case we were connected previously
    if (isConnected) {
        APP.wildix.eventEmitter.emit(WIS_EVENTS.RECONNECT);
    }
}

function onConnectionError(error) {
    console.log('WIS Error: ', error);
}

function onMessage(event) {
    const { data } = event;

    try {
        const message = JSON.parse(data);
        const { messageType, messageApp } = getWisMessageInfo(message);

        switch (messageType) {
        case WIS_MESSAGE_TYPE.RESPONSE:
            responseTypeMessage(message, messageType, messageApp);
            break;
        case WIS_MESSAGE_TYPE.EVENT:
            eventTypeMessage(message, messageApp);
            break;
        default:
            console.warn(`Unknown WIS message: ${message}`);
            break;
        }
    } catch (error) {
        console.error(`Could not parse WIS message JSON: ${data}`);
    }
}

function responseTypeMessage(message, messageType, messageApp) {
    switch (messageApp) {
    case WIS_MESSAGE_APP.SCREEN_CONTROL:
        APP.store.dispatch(eventScreenControlFromService(message));
        break;
    case WIS_MESSAGE_APP.HEADSET:
        console.warn('HEADSET responseTypeMessage');
        break;
    case WIS_MESSAGE_APP.WISERVICE:
        APP.store.dispatch(responseWiService(message, messageType, messageApp));
        break;
    default:
        console.warn(`Unknown WIS message: ${message}`);
        break;
    }
}

function eventTypeMessage(message, messageApp) {
    switch (messageApp) {
    case WIS_MESSAGE_APP.SCREEN_CONTROL:
        console.warn('controll eventTypeMessage');
        break;
    case WIS_MESSAGE_APP.HEADSET:
        handleHeadsetEvents(message);
        break;
    default:
        console.warn(`Unknown WIS message: ${message}`);
        break;
    }
}

/**
 * Trying to connect to the available ports 8888 - 8890
 * Waiting for connection is ready otherwise try to next available port
 * Note: WebSocket is open when readyState = 1
 *
 * @return {Promise<null>}
 */
export default async function getWisSocket() {
    if (wisSocket && wisSocket.readyState === 1) {
        return wisSocket;
    }

    let isOpenConnection = false;
    let port = getNextPort(null);

    while (port && !isOpenConnection) {
        const socket = new WebSocket(`wss://${WIS_DOMAIN}:${port}`);

        socket.onopen = () => {
            onConnectionOpened(socket);
        };

        socket.onclose = () => {
            onConnectionClosed();
        };

        socket.onerror = error => {
            onConnectionError(error);
        };

        socket.onmessage = message => {
            onMessage(message);
        };

        isOpenConnection = await isOpenWisConnection(socket);
        if (isOpenConnection) {
            wisSocket = socket;
        } else {
            wisSocket = null;
            port = getNextPort(port);
        }
    }

    return wisSocket;
}
